/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import * as preferencesActions from '../actions/preferencesActions';
import * as salesCatalystActions from '../actions/salesCatalystActions';
import * as insight360Actions from '../actions/insight360Actions';
import * as studyActions from '../actions/studyActions';
import { preferenceData, setModuleDataOnSave } from '../util/preferenceUtils';
import LeftNavigation from '../components/preference/LeftNavigation';
import DynamicInputFinder from '../components/preference/DynamicInputFinder';
import * as urls from '../actions/urlTypes';
import Modal from '../components/common/Modal/Modal';
import GenericButton from '../components/common/GenericButton';
import NoPathFound from '../components/preference/NoPathFound';
import WarningIcon from './WarningIcon';

import {
  PREFERENCE_POPUP_LABEL,
  PREFERENCE_STUDY_WEIGHTING,
  PREFERENCE_SALES_CATALYST,
  PREFERENCE_SALES_CATALYST_INDEX,
  RANGE_FILTER_DEFAULT,
  PREFERENCE_STUDY,
  PREFERENCE_SALES_CATALYST_STRENGTH_INDEX,
  PREFERENCE_SALES_CATALYST_WEAKNESS_INDEX,
  PAGE_VISIT_PREFERENCE,
  PAGE_VISIT_SESSION,
  SC_PACKAGE,
  PREFERENCE_BRAND_CATALYST,
  PREFERENCE_BRAND_CATALYST_INDEX,
  CROSSTAB_FEATUREID,
  QUICKREPORTS_FEATUREID,
  DATAHAUL_FEATUREID,
  STORIES_FEATUREID,
  BRAND_CATALYST_FEATUREID,
  SALES_CATALYST_FEATUREID,
  // TURNKEY_OMNIBUS_FEATUREID,
} from '../constants';
import { toastWarning } from '../util/toastUtils';
import { saveTrackingData } from '../util/trackerUtils';
import { isFeaturePresent, getStudyFromStudies, filterStudyList } from '../util/CommonUtils';

const mystyle = {
  width: '30%',
  height: '300px',
  left: '35%',
  top: '20%',
};

const AutoUpdateMessageModalStyle = {
  width: '45%',
  left: '30%',
  fontSize: '13px',
  fontWeight: 'bold',
  top: '15%',
};

const AutoUpdateHeaderStyle = {
  fontSize: '17px',
  fontWeight: 'normal',
};


class UserPreference extends Component {
  // eslint-disable-next-line react/static-property-placement
  static contextTypes = {
    router: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedMenu: props.lastLocation.mainModule !== undefined &&
        props.lastLocation.mainModule !== 'TurnkeyOmnibus' ? props.lastLocation.mainModule : 'Crosstab',
      selectedMainMenu: props.lastLocation.mainMenu !== undefined &&
        props.lastLocation.mainMenu !== 'Edge' ? props.lastLocation.mainMenu : 'Essentials',
      preferences: this.getUserPrefrences(),
      tabContent: {},
      tabTitle: {},
      preferenceData,
      cancelClicked: false,
      warning: [],
      afterUpdateStudy: {},
      beforeUpdateStudy: {},
      lastStudy: false,
      autoUpdate: false,
      preferenceUpdated: false,
      cancelAutoUpdateFlag: false,
      sessionScreen: props.screenType && props.screenType === 'session',
      disableApplyButtonForSession: true,
      hasCrosstabStudies: false,
      hasQuickReportsStudies: false,
      hasDatahaulStudies: false,
      hasStoriesStudies: false,
      hasBCStudies: false,
      hasSCStudies: false,
      isEssentialStudiesLoaded: false,
      isBCStudiesLoaded: false,
      isSCStudiesLoaded: false,
      showToastMenu: '',
    };
  }

  UNSAFE_componentWillMount() {
    const { hasBCStudies, hasSCStudies,
      hasCrosstabStudies,
      hasQuickReportsStudies,
      hasDatahaulStudies,
      hasStoriesStudies,
    } = this.props;

    if (hasCrosstabStudies !== undefined) {
      this.setState({ hasCrosstabStudies, isEssentialStudiesLoaded: true });
    }

    if (hasQuickReportsStudies !== undefined) {
      this.setState({ hasQuickReportsStudies, isEssentialStudiesLoaded: true });
    }

    if (hasDatahaulStudies !== undefined) {
      this.setState({ hasDatahaulStudies, isEssentialStudiesLoaded: true });
    }

    if (hasStoriesStudies !== undefined) {
      this.setState({ hasStoriesStudies, isEssentialStudiesLoaded: true });
    }

    if (hasBCStudies !== undefined) {
      this.setState({ hasBCStudies, isBCStudiesLoaded: true });
    }

    if (hasSCStudies !== undefined) {
      this.setState({ hasSCStudies, isSCStudiesLoaded: true });
    }
  }

  componentDidMount() {
    const { sessionScreen } = this.state;
    this.onMountMethod();
    if (!sessionScreen) {
      this.props.router.setRouteLeaveHook(this.props.route, () => {
        if (!_.isEqual(this.props.userPreferences, this.state.preferences)
          && !this.state.cancelClicked) {
          return PREFERENCE_POPUP_LABEL;
        }
        return null;
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!_.isEmpty(nextProps.userPreferences)) {
      if (!this.state.lastStudy) {
        if (!this.state.preferenceUpdated) {
          this.setState({ preferences: _.cloneDeep(nextProps.userPreferences) });
        }
        if (this.state.showToastMenu !== this.state.selectedMenu
          && nextProps.latestStudies && Object.keys(nextProps.latestStudies).length > 0
          && nextProps.studies && nextProps.studies.length > 0) {
          if (this.state.selectedMenu === 'Crosstab' || this.state.selectedMenu === 'QuickReports'
            || this.state.selectedMenu === 'DataHaul' || this.state.selectedMenu === 'Stories') {
            this.showToastWarning(this.state.selectedMenu, nextProps);
          }
        }
      }
      if (this.state.lastStudy &&
        (this.state.selectedMenu === 'Crosstab' || this.state.selectedMenu === 'QuickReports'
          || this.state.selectedMenu === 'DataHaul' || this.state.selectedMenu === 'Stories')
        && nextProps.latestStudies && Object.keys(nextProps.latestStudies).length > 0) {
        this.displayAutoUpdateModal(this.state.selectedMenu, nextProps);
      }
    }

    if (nextProps.hasCrosstabStudies !== undefined) {
      this.setState(() => ({ hasCrosstabStudies: nextProps.hasCrosstabStudies }), () => {
        this.setState({ isEssentialStudiesLoaded: true });
      });
    }

    if (nextProps.hasQuickReportsStudies !== undefined) {
      this.setState(() => ({ hasQuickReportsStudies: nextProps.hasQuickReportsStudies }), () => {
        this.setState({ isEssentialStudiesLoaded: true });
      });
    }

    if (nextProps.hasDatahaulStudies !== undefined) {
      this.setState(() => ({ hasDatahaulStudies: nextProps.hasDatahaulStudies }), () => {
        this.setState({ isEssentialStudiesLoaded: true });
      });
    }

    if (nextProps.hasStoriesStudies !== undefined) {
      this.setState(() => ({ hasStoriesStudies: nextProps.hasStoriesStudies }), () => {
        this.setState({ isEssentialStudiesLoaded: true });
      });
    }

    if (nextProps.hasBCStudies !== undefined) {
      this.setState(() => ({ hasBCStudies: nextProps.hasBCStudies }), () => {
        this.setState({ isBCStudiesLoaded: true });
      });
    }

    if (nextProps.hasSCStudies !== undefined) {
      this.setState(() => ({ hasSCStudies: nextProps.hasSCStudies }), () => {
        this.setState({ isSCStudiesLoaded: true });
      });
    }
  }

  componentWillUnmount() {
    sessionStorage.removeItem('unsavedPrefData');
  }

  onMountMethod = () => {
    if (this.props.loginResponse) {
      if (this.props.userPreferences && this.props.studies
        && typeof (this.props.screenType) === 'undefined') {
        this.getLatestStudies(this.props.userPreferences);
      }
      const apiCallsArr = [];
      const { uid, currentAccountId, token } = this.props.loginResponse.data;
      const { modulePermissions } = this.props;
      if (currentAccountId && !_.isEmpty(modulePermissions)) {
        if (this.checkPermission(BRAND_CATALYST_FEATUREID) && !this.props.hasBCStudies) {
          apiCallsArr.push(this.props.insight360Actions.get360Study(token, uid, currentAccountId));
        }
        if (this.checkPermission(SALES_CATALYST_FEATUREID) && !this.props.hasSCStudies) {
          apiCallsArr.push(this.props.salesCatalystActions.getsalesCatalystStudy(token, uid, currentAccountId));
        }
      }

      Promise.all(apiCallsArr)
      .then(() => {
      });
      const selectedMenu = this.props.lastLocation.mainModule ?
        this.props.lastLocation.mainModule : this.state.selectedMenu;
      saveTrackingData({
        uid: this.props.loginResponse.data.uid,
        accid: this.props.activeAccountId,
        moduleName: selectedMenu.toUpperCase(),
        action: this.props.screenType && this.props.screenType === 'session' ?
          PAGE_VISIT_SESSION : PAGE_VISIT_PREFERENCE,
      });
    }
  }

  // Add warning info to state
  setPreferenceWarning = data => {
    const { warning } = this.state;
    const stateWarning = _.cloneDeep(warning);
    const fndItemIndex = _.findIndex(stateWarning, { section: data.section });
    if (fndItemIndex !== -1 && data.message !== undefined) {
      stateWarning[fndItemIndex] = {
        ...stateWarning[fndItemIndex],
        tab: data.tab,
        section: data.section,
        title: data.title,
        message: data.message,
      };
    } else if (fndItemIndex !== -1) {
      _.remove(stateWarning, n => n.section === stateWarning[fndItemIndex].section);
    } else if (data.message !== undefined) {
      stateWarning.push(data);
    }
    this.setState({
      warning: stateWarning,
    });
  }

  // Warning Modal OK button action
  warningModalClickFn = () => {
    const { warning } = this.state;
    this.handleMenuSelection(warning[0].tab);
    this.warningPreferenceModal.hide();
  }

  rangeFilterValidation = data => {
    if (data[PREFERENCE_SALES_CATALYST]) {
      _.forEach(_.keys(data[PREFERENCE_SALES_CATALYST]), key => {
        if (key === PREFERENCE_SALES_CATALYST_INDEX ||
          key === PREFERENCE_SALES_CATALYST_STRENGTH_INDEX ||
          key === PREFERENCE_SALES_CATALYST_WEAKNESS_INDEX) {
          data = this.checkRange(data, key, PREFERENCE_SALES_CATALYST);
        }
      });
    }
    if (data[PREFERENCE_BRAND_CATALYST]) {
      _.forEach(_.keys(data[PREFERENCE_BRAND_CATALYST]), key => {
        if (key === PREFERENCE_BRAND_CATALYST_INDEX) {
          data = this.checkRange(data, key, PREFERENCE_BRAND_CATALYST);
        }
      });
    }
    return data;
  }

  checkRange = (data, key, tabName) => {
    const range = data[tabName][key].value;
    if (range.length === 1 && range[0] === '') {
      data[tabName][key].value =
        RANGE_FILTER_DEFAULT[data[tabName][key].selectedOption];
    }
    if (range.length === 2 && (range[0] === '' || range[1] === '' || range[0] > range[1])) {
      data[tabName][key].value =
        RANGE_FILTER_DEFAULT[data[tabName][key].selectedOption];
    }
    return data;
  }

  getLatestStudyType = (productNo, studies) => {
    let studyList;
    if (this.state.selectedMenu === 'Crosstab') {
      studyList = filterStudyList(studies, CROSSTAB_FEATUREID);
    } else if (this.state.selectedMenu === 'QuickReports') {
      studyList = filterStudyList(studies, QUICKREPORTS_FEATUREID);
    } else if (this.state.selectedMenu === 'DataHaul') {
      studyList = filterStudyList(studies, DATAHAUL_FEATUREID);
    } else if (this.state.selectedMenu === 'Stories') {
      studyList = filterStudyList(studies, STORIES_FEATUREID);
    } else if (this.state.selectedMenu === 'BrandCatalyst') {
      studyList = filterStudyList(studies, BRAND_CATALYST_FEATUREID);
    } else if (this.state.selectedMenu === 'SalesCatalyst') {
      studyList = filterStudyList(studies, SALES_CATALYST_FEATUREID);
    }
    const selectedStudy = getStudyFromStudies(studyList, productNo);
    if (selectedStudy && Object.keys(selectedStudy).length > 0) {
      return selectedStudy;
    }
    studyList = studyList.length>0 ? studyList[0].sl[0] : [];
    return studyList;
  };

  showToastWarning = (menu, nextProps) => {
    let preferenceProp = '_ct';
    let featureId = CROSSTAB_FEATUREID;
    if (menu === 'QuickReports') {
      preferenceProp = '_qr';
      featureId = QUICKREPORTS_FEATUREID;
    } else if (menu === 'DataHaul') {
      preferenceProp = '_dh';
      featureId = DATAHAUL_FEATUREID;
    } else if (menu === 'Stories') {
      preferenceProp = '_st';
      featureId = STORIES_FEATUREID;
    }
    let productNo = this.state.preferences[preferenceProp]._ds;
    if (productNo === -1) {
      productNo = nextProps.studies[0].sl[0].pn;
    }
    this.setState({ showToastMenu: menu });
    if (this.checkPermission(featureId) && this.state.preferences && this.state.preferences[preferenceProp]
      && !this.state.preferences[preferenceProp]._aus && Object.keys(nextProps.latestStudies).length > 0
      && productNo !== nextProps.latestStudies[preferenceProp].productNo) {
      toastWarning(
        <span style={{ color: 'black', width: '400px' }}>
          A newer study is available for your selected study on Start-up preference. To update select
        <span style={{ fontWeight: 'bold' }}>
          {this.getLatestStudyType(nextProps.latestStudies[preferenceProp].productNo, nextProps.studies).sd}
        </span></span>);
    }
  }

  displayAutoUpdateModal = (menu, nextProps) => {
    let preferenceProp = '_ct';
    if (menu === 'QuickReports') {
      preferenceProp = '_qr';
    } else if (menu === 'DataHaul') {
      preferenceProp = '_dh';
    } else if (menu === 'Stories') {
      preferenceProp = '_st';
    }
    let productNo = this.state.preferences[preferenceProp]._ds;
    if (productNo === -1) {
      productNo = nextProps.studies[0].sl[0].pn;
    }
    if (productNo !== nextProps.latestStudies[preferenceProp].productNo) {
      this.setState({
        afterUpdateStudy: this.getLatestStudyType(nextProps.latestStudies[preferenceProp].productNo, nextProps.studies),
        lastStudy: false,
      });
      this.autoupdateModal.show();
    }
    this.setState({ lastStudy: false });
  }

  saveUserPreferences = () => {
    const preferences = _.clone(this.state.preferences);
    const cloneStatePreferences = this.rangeFilterValidation(_.clone(this.state.preferences));

    if (!_.isEmpty(this.state.warning)) {
      this.warningPreferenceModal.show();
      return false;
    }
    _.forEach(_.keys(this.props.userPreferences), key => {
      const modified = _.isEqual(this.props.userPreferences[key], this.state.preferences[key]);
      preferences[key].modified = !modified;
    });
    if (cloneStatePreferences._ct._ds === -1 && cloneStatePreferences._ct._aus) {
      cloneStatePreferences._ct._ds = this.getLatestStudyType(-1, this.props.studies).productNo;
    }
    if (cloneStatePreferences._qr._ds === -1 && cloneStatePreferences._qr._aus) {
      cloneStatePreferences._qr._ds = this.getLatestStudyType(-1, this.props.studies).productNo;
    }
    if (cloneStatePreferences._dh._ds === -1 && cloneStatePreferences._dh._aus) {
      cloneStatePreferences._dh._ds = this.getLatestStudyType(-1, this.props.studies).productNo;
    }
    if (cloneStatePreferences._st._ds === -1 && cloneStatePreferences._st._aus) {
      cloneStatePreferences._st._ds = this.getLatestStudyType(-1, this.props.studies).productNo;
    }
    this.setState({ lastStudy: true });
    this.props.preferencesActions.saveUserPreferences(
      this.props.loginResponse.data.uid,
      this.props.activeAccountId,
      cloneStatePreferences
    ).then(response => {
      if (response) {
        this.props.setModuleDataOnSave(preferences);
        this.cancelPreferences();
      }
    });
    return true;
  };

  saveSessionPreference = () => {
    const { salesCatalystActions, insight360Actions, sessionClose, saveSettingsFn, defaultSection,
      sessionType } = this.props;
    const cloneStatePreferences = this.rangeFilterValidation(_.clone(this.state.preferences));
    if (!_.isEmpty(this.state.warning)) {
      this.warningPreferenceModal.show();
      return false;
    }
    if (sessionType && sessionType === PREFERENCE_BRAND_CATALYST) {
      insight360Actions.saveBrandCatalystSessionData(
        cloneStatePreferences[PREFERENCE_BRAND_CATALYST],
        true
      );
    } else if (sessionType && sessionType === PREFERENCE_SALES_CATALYST) {
      if (!_.isEmpty(defaultSection) && defaultSection === _.toLower(SC_PACKAGE)) {
        saveSettingsFn(cloneStatePreferences);
      } else {
        salesCatalystActions.saveSalesCatalystSessionData(
          cloneStatePreferences[PREFERENCE_SALES_CATALYST],
          true
        );
      }
    }
    sessionClose();
    return undefined;
  }

  resetAndSaveSessionPreference = () => {
    const { userPreferences, salesCatalystActions, insight360Actions, sessionClose,
      sessionType } = this.props;
    if (sessionType && sessionType === PREFERENCE_SALES_CATALYST) {
      salesCatalystActions.saveSalesCatalystSessionData(
        _.cloneDeep(userPreferences[PREFERENCE_SALES_CATALYST]),
        true
      );
    } else if (sessionType && sessionType === PREFERENCE_BRAND_CATALYST) {
      insight360Actions.saveBrandCatalystSessionData(
        _.cloneDeep(userPreferences[PREFERENCE_BRAND_CATALYST]),
        true
      );
    }
    sessionClose();
  }

  handleWeightTypes = (keys, val, weightType, preferencesWeightType, storedPref) => {
    const _clonedPreferences = !_.isEmpty(this.state.preferences) ?
      _.cloneDeep(this.state.preferences) : _.cloneDeep(storedPref);
    this.handleStudySelectorChange(keys, val, weightType,
      preferencesWeightType, _clonedPreferences);
  };

  handleStudySelectorChange = (
    keys, val, weightType, preferencesWeightType, _clonedPreferences) => {
    const updatedWeightTypes = preferencesWeightType || weightType;
    const studyWeight = weightType > 2 ? 'Population' : updatedWeightTypes;
    _clonedPreferences[keys[0]][PREFERENCE_STUDY_WEIGHTING] = studyWeight;
    _clonedPreferences[keys[0]][PREFERENCE_STUDY] = val;
    this.setState(() => ({
      preferences: _clonedPreferences,
    }));
  }

  handleAutoUpdateStudy = () => {
    this.setState({ autoUpdate: true, cancelAutoUpdateFlag: false });
    this.autoupdateModal.hide();
  }

  cancelAutoUpdate = () => {
    this.setState({ cancelAutoUpdateFlag: true, autoUpdate: false });
    this.autoupdateModal.hide();
  }

  toggleCancelFlag = () => {
    this.setState({ cancelAutoUpdateFlag: false });
  }

  getUserPrefrences = () => {
    const { sessionType, screenType, scSessionConfiguration, bcSessionConfiguration,
      userPreferences } = this.props;
    const preferenceData = {};
    if (screenType && screenType === 'session') {
      const sessionData = sessionType === PREFERENCE_BRAND_CATALYST ? bcSessionConfiguration :
      scSessionConfiguration;
      return _.cloneDeep(sessionData);
    } if (userPreferences !== undefined) {
      return _.cloneDeep(userPreferences);
    }
    return preferenceData;
  };

  updatePreferences = (dbKey, val, weightType, autoUpdateFlag) => {
    if (this.props.screenType && this.props.screenType === 'session') {
      this.setState({ disableApplyButtonForSession: false });
    }
    const keys = dbKey.split('.');
    let value = _.clone(val);
    if (_.indexOf(['_sc._tm', '_sc._ep', '_sc._bp'], dbKey) !== -1) {
      if (value.length > 0) {
        value = [{
          expression: val[0].expression,
          label: val[0].label,
        }];
      }
    }
    const { preferences } = this.state;
    const _clonedPreferences = _.cloneDeep(preferences);
    if (_.indexOf(['_ct._ds', '_qr._ds', '_dh._ds', '_st._ds'], dbKey) !== -1) {
      _clonedPreferences[keys[0]]._sw = weightType;
    }
    if (!_.isEmpty(_clonedPreferences)) {
      _clonedPreferences[keys[0]][keys[1]] = value;
    }

    this.setState({ preferences: _clonedPreferences, autoUpdate: false, preferenceUpdated: true }
      , () => {
        if (this.state.selectedMenu === 'Crosstab'
          || this.state.selectedMenu === 'QuickReports'
          || this.state.selectedMenu === 'DataHaul'
          || this.state.selectedMenu === 'Stories') {
          if (dbKey === '_ct._ds' || dbKey === '_ct._aus') {
            this.updatePrefWithLatestStudy(_clonedPreferences._ct._ds,
              _clonedPreferences._ct._aus, autoUpdateFlag, _clonedPreferences);
          } else if (dbKey === '_qr._ds' || dbKey === '_qr._aus') {
            this.updatePrefWithLatestStudy(_clonedPreferences._qr._ds,
              _clonedPreferences._qr._aus, autoUpdateFlag, _clonedPreferences);
          } else if (dbKey === '_dh._ds' || dbKey === '_dh._aus') {
            this.updatePrefWithLatestStudy(_clonedPreferences._dh._ds,
              _clonedPreferences._dh._aus, autoUpdateFlag, _clonedPreferences);
          } else if (dbKey === '_st._ds' || dbKey === '_st._aus') {
            this.updatePrefWithLatestStudy(_clonedPreferences._st._ds,
              _clonedPreferences._st._aus, autoUpdateFlag, _clonedPreferences);
          }
        }

        if (!_.isEqual(this.props.userPreferences, this.state.preferences)) {
          sessionStorage.setItem('unsavedPrefData', 'true');
        } else if (sessionStorage.unsavedPrefData) {
          sessionStorage.removeItem('unsavedPrefData');
        }
      });
  }

  updatePrefWithLatestStudy = (prefStudy, prefAutoUpdate, autoUpdateFlag, _clonedPreferences) => {
    if (prefAutoUpdate && !autoUpdateFlag) {
      const studyReq = this.getLatestStudyType(prefStudy, this.props.studies);
      this.getLatestStudies(_clonedPreferences);
      this.setState({
        lastStudy: true,
        beforeUpdateStudy: studyReq,
      });
    } else if (!prefAutoUpdate && !autoUpdateFlag) {
      this.getLatestStudies(_clonedPreferences);
      this.setState({
        lastStudy: false,
      });
    }
  }

  getLatestStudies = _clonedPreferences => {
    const studyReq = {};

    studyReq._ct = this.getLatestStudyReq(_clonedPreferences._ct._ds);
    studyReq._qr = this.getLatestStudyReq(_clonedPreferences._qr._ds);
    studyReq._dh = this.getLatestStudyReq(_clonedPreferences._dh._ds);
    studyReq._st = this.getLatestStudyReq(_clonedPreferences._st._ds);

    if (this.checkPermission(CROSSTAB_FEATUREID) || this.checkPermission(QUICKREPORTS_FEATUREID)
      || this.checkPermission(DATAHAUL_FEATUREID) || this.checkPermission(STORIES_FEATUREID)) {
      this.setState({ showToastMenu: '' });
      this.props.studyActions.getLatestStudy(
        this.props.loginResponse.data.uid,
        this.props.activeAccountId,
        studyReq,
      );
    }
  }

  getLatestStudyReq = prefStudy => {
    const studyReq = this.getLatestStudyType(prefStudy, this.props.studies);

    return {
      study: studyReq.st,
      productNo: studyReq.pn,
      studyDescription: studyReq.sd,
    };
  }

  showPreferenceModal = () => {
    const { screenType, sessionType, scSessionConfiguration, bcSessionConfiguration,
      userPreferences, defaultSection } = this.props;
    const { preferences } = this.state;
    const sessionConfigData = sessionType === PREFERENCE_BRAND_CATALYST ? bcSessionConfiguration :
      scSessionConfiguration;
    if (screenType && screenType === 'session' &&
    _.isEqual(sessionConfigData, preferences)) {
      this.cancelPreferences();
    } else if (_.isEqual(userPreferences, preferences)) {
      this.cancelPreferences();
    } else if (!_.isEmpty(defaultSection)) {
      this.cancelPreferences();
    } else {
      this.cancelPreferenceModal.show();
    }
  }

  cancelPreferences = () => {
    const { sessionClose } = this.props;
    const { sessionScreen } = this.state;
    let mainMenu = '';
    let mainModule = '';
    if (!_.isEmpty(this.props.lastLocation)) {
      mainMenu = this.props.lastLocation.mainMenu;
      mainModule = this.props.lastLocation.mainModule;
    } else {
      mainMenu = this.state.selectedMainMenu;
      mainModule = this.state.selectedMenu;
    }
    this.setState({ cancelClicked: true }, () => {
      if (!sessionScreen) {
        if ((mainMenu === 'Catalyst' && mainModule === 'BrandCatalyst')) {
          this.props.preferencesActions.setPreferenceFlag('brandCatalyst', false);
        }
        this.context.router
          .push(`${urls.APP_ROOT_URL}/${mainMenu.toLowerCase()}/${mainModule.toLowerCase()}`);
      } else {
        sessionClose();
      }
    });
  };

  handleMenuSelection = menu => {
    let selectedMainMenu = '';
    switch (menu) {
      case 'Crosstab': selectedMainMenu = 'Essentials'; break;
      case 'QuickReports': selectedMainMenu = 'Essentials'; break;
      case 'DataHaul': selectedMainMenu = 'Essentials'; break;
      case 'Stories': selectedMainMenu = 'Essentials'; break;
      case 'BrandCatalyst': selectedMainMenu = 'Catalyst'; break;
      case 'SalesCatalyst': selectedMainMenu = 'Catalyst'; break;
      case 'TurnkeyOmnibus': selectedMainMenu = 'Omnibus'; break;
      default: break;
    }
    saveTrackingData({
      uid: this.props.loginResponse.data.uid,
      accid: this.props.activeAccountId,
      moduleName: (menu).toUpperCase(),
      action: PAGE_VISIT_PREFERENCE,
    });
    this.setState({ selectedMainMenu, selectedMenu: menu });
    if ((menu === 'Crosstab' || menu === 'QuickReports'
      || menu === 'DataHaul' || menu === 'Stories')
      && this.props.latestStudies && Object.keys(this.props.latestStudies).length > 0) {
      this.showToastWarning(menu, this.props);
    }
  }

  handleAccordion = tabId => {
    if (this.state.tabContent[tabId].style.display === 'block') {
      this.state.tabContent[tabId].style.display = 'none';
      this.state.tabTitle[tabId].classList.remove('title-custom');
      this.state.tabTitle[tabId].classList.add('title-custom-close');
    } else {
      this.state.tabContent[tabId].style.display = 'block';
      this.state.tabTitle[tabId].classList.remove('title-custom-close');
      this.state.tabTitle[tabId].classList.add('title-custom');
    }
  }

  showModulePreference = subMenu => {
    const menuObj = subMenu.featureId;
    return isFeaturePresent(menuObj, this.props.modulePermissions);
  }

  isModuleContainsStudies = subMenu => {
    if (subMenu === 'Crosstab') {
      return this.state.hasCrosstabStudies;
    } if (subMenu === 'QuickReports') {
      return this.state.hasQuickReportsStudies;
    } if (subMenu === 'DataHaul') {
      return this.state.hasDatahaulStudies;
    } if (subMenu === 'Stories') {
      return this.state.hasStoriesStudies;
    } if (subMenu === 'BrandCatalyst') {
      return this.state.hasBCStudies;
    } if (subMenu === 'SalesCatalyst') {
      return this.state.hasSCStudies;
    }
    return true;
  }

  isModuleStudiesLoaded = subMenu => {
    if (subMenu === 'Crosstab') {
      return this.state.isEssentialStudiesLoaded;
    } if (subMenu === 'QuickReports') {
      return this.state.isEssentialStudiesLoaded;
    } if (subMenu === 'DataHaul') {
      return this.state.isEssentialStudiesLoaded;
    } if (subMenu === 'Stories') {
      return this.state.isEssentialStudiesLoaded;
    } if (subMenu === 'BrandCatalyst') {
      return this.state.isBCStudiesLoaded;
    } if (subMenu === 'SalesCatalyst') {
      return this.state.isSCStudiesLoaded;
    }
    return false;
  }

  disableButton = () => {
    const { preferences } = this.state;
    // const { sessionType, scSessionConfiguration, bcSessionConfiguration } = this.props;
    if (this.props.screenType && this.props.screenType === 'session') {
      // const sessionConfigData = sessionType === PREFERENCE_BRAND_CATALYST ? bcSessionConfiguration :
      // scSessionConfiguration;
      // return _.isEqual(sessionConfigData, preferences);
      return this.state.disableApplyButtonForSession;
    } if (this.props.userPreferences !== undefined) {
      return _.isEqual(this.props.userPreferences, preferences);
    }
    return false;
  };

  disableResetButton = () => {
    const { preferences } = this.state;
    const { userPreferences, screenType, sessionType } = this.props;
    if (screenType && screenType === 'session') {
      const sessionObject = _.cloneDeep(preferences[sessionType]);
      if (sessionObject && sessionObject.modified) {
        delete sessionObject.modified;
      }
      return _.isEqual(userPreferences[sessionType], sessionObject);
    }
    return false;
  };

  checkPermission(moduleFeature) {
    const { modulePermissions } = this.props;
    let hasFeature = false;
    if (modulePermissions.length > 0) {
      hasFeature = isFeaturePresent(moduleFeature, modulePermissions);
    }
    return hasFeature;
  }

  render() {
    const { defaultSection } = this.props;
    const { preferences, selectedMenu, selectedMainMenu,
      tabTitle, tabContent, warning, sessionScreen } = this.state;
    const rightItems = this.state.preferenceData;
    return (!this.props.loginResponse.data.universityUser ?
      <div className={`row expanded preferences ${sessionScreen ? 'session-preferences' : ''}`}>
        {!sessionScreen && <LeftNavigation
          listItems={rightItems}
          handleMenuSelection={this.handleMenuSelection}
          selectedMenu={selectedMenu}
          mainMenu={selectedMainMenu}
        />}
        <div className={`column ${sessionScreen ? 'small-12' : 'large-10 medium-10'} preference-content`}>
          <div className="row expanded top-btn-content">
            <div className="column large-6 medium-6">
              <button
                type="button"
                className="btn apply-save-btn"
                onClick={() => sessionScreen ? this.saveSessionPreference()
                  : this.saveUserPreferences()}
                disabled={this.disableButton()}
              >{`${sessionScreen ? 'Apply' : 'Save & Apply'}`}</button>
              <button
                type="button"
                className="btn cancel-back-btn"
                onClick={this.showPreferenceModal}
              >Cancel</button>
              {this.props.screenType && this.props.screenType === 'session'
                && _.isEmpty(this.props.defaultSection) &&
                <button
                  type="button"
                  className="btn reset-save-btn"
                  onClick={this.resetAndSaveSessionPreference}
                  disabled={this.disableResetButton()}
                >Reset
                </button>}
            </div>
            {!sessionScreen && <div className="column large-6 medium-6">
              <span className="float-right right-corner-label">Preferences / {selectedMainMenu} /
                <span> {selectedMenu}</span></span>
            </div>}
          </div>
          <div className="row expanded main-preference">
            <div className="column large-12 medium-12 preference-container">
              {rightItems.map(mainMenu => {
                return (
                  <ul
                    className="accordion custom-accordion"
                    key={mainMenu.key}
                    data-accordion
                    data-allow-all-closed="true"
                  >{mainMenu.mainMenu === selectedMainMenu &&
                    mainMenu.subMenu.map(subMenu => {
                      if (subMenu.menuName === selectedMenu) {
                        if (this.showModulePreference(subMenu)) {
                          if (!this.isModuleStudiesLoaded(selectedMenu)) {
                            return <div>Loading...</div>;
                          } if (!this.isModuleContainsStudies(selectedMenu)) {
                            return (
                              <div className="no-study-message">
                                <WarningIcon />
                                <p>
                                  You do not currently have studies to the {selectedMenu} application.
                                  Please contact your Account Manager to learn more about your studies.
                                </p>
                              </div>
                            );
                          } 
                            return (subMenu.menuName === selectedMenu &&
                        subMenu.tabs ?
                        subMenu.tabs.map((tab, index) => {
                          if (((!sessionScreen && (tab.preferencesVisible || tab.preferencesVisible === undefined)) ||
                          (sessionScreen && (tab.session || tab.session === undefined))) &&
                           (!defaultSection || (defaultSection && (!tab.tabId || tab.tabId === defaultSection)))) {
                            return (
                              <li
                                id={index}
                                key={tab.tabId}
                                className={`${tab.tabId ? 'accordion-item' : ''}`}
                                data-accordion-item
                              >
                              {tab.tabId && <button
                                type="button"
                                ref={node => (tabTitle[tab.tabId] = node)}
                                onClick={() => this.handleAccordion(tab.tabId)}
                                className="title-custom"
                              >{tab.tabName}</button>}
                              <div
                                className={`${tab.tabId ? 'accordion-content section-holder' :
                                  'accordion-smart-content section-holder'}`}
                                ref={node => (tabContent[tab.tabId] = node)}
                                style={{ display: 'block' }}
                                data-tab-content
                              >{tab.sections && tab.sections.map((section, index) => {
                                if (!sessionScreen || (sessionScreen &&
                                  (section.session || section.session === undefined))) {
                                  return (
                                    <div
                                      key={`section${index}`}
                                      className={`${tab.tabId ? 'input-section' : ''} `}
                                    >{section.section && section.section.map(row => {
                                    if (row.visible && (!sessionScreen || (sessionScreen &&
                                      (row.session || row.session === undefined)))) {
                                      return (<div key={row.rowId} className="row expanded bottom-padding">
                                        {row.row.map(field => {
                                          if (field.dbKey !== undefined && field.defaultValue !== undefined) {
                                            const keys = field.dbKey.split('.');
                                            const parentKey = keys[0];
                                            const childKey = keys[1];
                                            if (preferences[parentKey] !== undefined &&
                                              preferences[parentKey][childKey] !== undefined) {
                                              field.defaultValue = preferences[parentKey][childKey];
                                            }
                                            return (
                                              <DynamicInputFinder
                                                key={field.dbKey}
                                                field={field}
                                                updatePreferences={this.updatePreferences}
                                                handleWeightTypes={this.handleWeightTypes}
                                                modifiedPreferences={preferences}
                                                userPreferences={this.props.userPreferences}
                                                setPreferenceWarning={this.setPreferenceWarning}
                                                autoUpdate={this.state.autoUpdate}
                                                latestStudies={this.props.latestStudies}
                                                cancelAutoUpdateFlag={this.state.cancelAutoUpdateFlag}
                                                toggleCancelFlag={this.toggleCancelFlag}
                                                sessionScreen={sessionScreen}
                                                defaultSection={defaultSection}
                                              />
                                            );
                                          }
                                          return null;
                                        })}
                                      </div>);
                                    }
                                    return null;
                                  })}
                                  </div>);
                                }
                                return null;
                              })
                                }
                              </div></li>);
                          }
                          return null;
                        }) : subMenu.menuName === selectedMenu &&
                        <div key={subMenu.menuName} className="coming-soon">Coming soon...</div>
                      );
                           // end of if else block of is modules study list availbale (isModuleContainsStudies)
                        } 
                          return (
                          <div className="coming-soon">
                            Sorry, You don&apos;t have enough permission to view this page.
                          </div>
                          );
                        
                      }
                      return null;
                    })}
                  </ul>);
              })}
            </div>
          </div>
        </div>
        <Modal
          title={(this.props.screenType && this.props.screenType === 'session') ? 'Session settings not saved'
          : 'Preferences not saved'}
          ref={node => {
            this.cancelPreferenceModal = node;
            return this.cancelPreferenceModal;
          }}
          dialogStyles={mystyle}
        >
          <div>
            <p>
              Are you sure you want to continue? Your {(this.props.screenType &&
                this.props.screenType === 'session') ? 'session' : 'preferences'} will
              not be saved or applied if you click OK
            </p>
          </div>
          <div>
            <div className="button-group  float-right">
              <GenericButton name="OK" onBtnClick={() => this.cancelPreferences()} />
              <GenericButton
                name="Cancel"
                onBtnClick={() => this.cancelPreferenceModal.hide()}
              />
            </div>
          </div>
        </Modal>
        <Modal
          title={warning[0] && warning[0].title !== undefined ? warning[0].title : ''}
          ref={node => {
            this.warningPreferenceModal = node;
            return this.warningPreferenceModal;
          }}
          dialogStyles={mystyle}
        >
          <div className="text-center">
            <p>{warning[0] && warning[0].message}</p>
            <div className="button-group">
              <GenericButton
                name="OK"
                onBtnClick={() => this.warningModalClickFn()}
              />
            </div>
          </div>
        </Modal>
        <Modal
          title="Study Updated"
          ref={node => {
            this.autoupdateModal = node;
            return this.autoupdateModal;
          }}
          dialogStyles={AutoUpdateMessageModalStyle}
          headerStyles={AutoUpdateHeaderStyle}
          closeTracker={() => this.cancelAutoUpdate()}
        >
          <p>
            The currently selected study is not the most recently released version of your
            selected study type. Your study on start-up will be changed from
            <span style={{ fontWeight: 'bold', color: 'red' }}>
              {this.state.beforeUpdateStudy.sd}
            </span> to <span style={{ fontWeight: 'bold', color: 'red' }}>{this.state.afterUpdateStudy.sd}</span>
          </p>
          <GenericButton
            name="OK"
            btnStyle="button margin-left-10 margin-right-10 margin-top-5 auto-update-button"
            onBtnClick={() => this.handleAutoUpdateStudy()}
          />
        </Modal>
      </div> : <NoPathFound />);
  }
}

UserPreference.propTypes = {
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      universityUser: PropTypes.bool,
      currentAccountId: PropTypes.number,
      token: PropTypes.string,
    }),
  }),
  studies: PropTypes.arrayOf(PropTypes.object),
  userPreferences: PropTypes.shape({}),
  scSessionConfiguration: PropTypes.shape({}),
  bcSessionConfiguration: PropTypes.shape({}),
  lastLocation: PropTypes.shape({
    mainModule: PropTypes.string,
    mainMenu: PropTypes.string,
  }),
  activeAccountId: PropTypes.number,
  preferencesActions: PropTypes.shape({
    getUserPrefrences: PropTypes.func,
    saveUserPreferences: PropTypes.func,
    setPreferenceFlag: PropTypes.func,
  }),
  studyActions: PropTypes.shape({
    getLatestStudy: PropTypes.func,
  }),
  salesCatalystActions: PropTypes.shape({
    saveSalesCatalystSessionData: PropTypes.func,
    getsalesCatalystStudy: PropTypes.func,
  }),
  insight360Actions: PropTypes.shape({
    saveSalesCatalystSessionData: PropTypes.func,
    get360Study: PropTypes.func,
    saveBrandCatalystSessionData: PropTypes.func,
  }),
  setModuleDataOnSave: PropTypes.func,
  latestStudies: PropTypes.arrayOf(PropTypes.object),
  screenType: PropTypes.string,
  defaultSection: PropTypes.string,
  sessionType: PropTypes.string,
  sessionClose: PropTypes.func,
  saveSettingsFn: PropTypes.func,
  modulePermissions: PropTypes.instanceOf(Array),
  hasCrosstabStudies: PropTypes.bool,
  hasQuickReportsStudies: PropTypes.bool,
  hasDatahaulStudies: PropTypes.bool,
  hasStoriesStudies: PropTypes.bool,
  hasSCStudies: PropTypes.bool,
  hasBCStudies: PropTypes.bool,
  router: PropTypes.shape({
    setRouteLeaveHook: PropTypes.func,
  }),
  route: PropTypes.shape({}),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    userPreferences: state.preferences.userPreferences,
    lastLocation: state.preferences.lastLocation,
    latestStudies: state.study.latestStudies,
    studies: state.study.studies,
    scSessionConfiguration: state.salesCatalyst.scSessionConfiguration,
    bcSessionConfiguration: state.insight360.bcSessionConfiguration,
    modulePermissions: state.userDetail.permissions,
    hasCrosstabStudies: state.study.hasCrosstabStudies,
    hasQuickReportsStudies: state.study.hasQuickReportsStudies,
    hasDatahaulStudies: state.study.hasDatahaulStudies,
    hasStoriesStudies: state.study.hasStoriesStudies,
    hasBCStudies: state.study.hasBCStudies,
    hasSCStudies: state.study.hasSCStudies,
    // insight360study: state.study.insight360study,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    studyActions: bindActionCreators(studyActions, dispatch),
    preferencesActions: bindActionCreators(preferencesActions, dispatch),
    setModuleDataOnSave: bindActionCreators(setModuleDataOnSave, dispatch),
    salesCatalystActions: bindActionCreators(salesCatalystActions, dispatch),
    insight360Actions: bindActionCreators(insight360Actions, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserPreference));
